<!--报工未入库报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['organizationName']"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="organizationName"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationName"
          :selectData="inventOrg"
          :selectItem="{ value: 'label', label: 'label' }"
        />
        <global-select
          slot="wipEntityName"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.wipEntityName"
          selectType="selectSearch"
          requestApi="/inv/invWipCompletedNotStored/wipEntityNameCombobox"
          :selectItem="{ value: 'realValue', label: 'realValue' }"
          searchParam="wipEntityName"
        />
        <global-select
          slot="lotNumber"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.lotNumber"
          selectType="selectSearch"
          requestApi="/inv/invWipCompletedNotStored/lotNumberComboBoxVO"
          :selectItem="{ value: 'realValue', label: 'realValue' }"
          searchParam="lotNumber"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvWipCompletedNotStoredExportReport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          rowKey="id"
          :tableProps="tableProps"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiInvWipCompletedNotStoredExportReport, apiInvWipCompletedNotStoredList } from '@/api/report/ordinary-report'

export default {
  name: 'ReportAndNoWarehouse',
  components: { DownloadModal },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiInvWipCompletedNotStoredExportReport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvWipCompletedNotStoredList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        organizationName: undefined,
        wipEntityName: undefined,
        lotNumber: undefined,
        packageReporting: undefined,
        packageReportingStartDate: undefined,
        packageReportingEndDate: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '工厂', decorator: ['organizationName'], type: 'organizationName' },
        { label: '工单号', decorator: ['wipEntityName'], type: 'wipEntityName' },
        { label: '批次号', decorator: ['lotNumber'], type: 'lotNumber' },
        {
          label: '包装报工日期',
          type: 'range',
          decorator: ['packageReporting'],
          disposeFormat: {
            packageReportingStartDate: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            packageReportingEndDate: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        { title: '工厂', dataIndex: 'organizationName', align: 'center', width: 120 },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 120 },
        { title: '批次号', dataIndex: 'lotNumber', align: 'center', width: 140 },
        { title: '包装报工日期', dataIndex: 'packageReportingDate', align: 'center', width: 120 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 110 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 100 },
        { title: '规格描述', dataIndex: 'description', align: 'center', width: 160, ellipsis: true },
        { title: '工单数量', dataIndex: 'wipQty', align: 'center', width: 100 },
        { title: '完工数量', dataIndex: 'quantityCompleted', align: 'center', width: 100 },
        { title: '入库数量', dataIndex: 'receiptQty', align: 'center', width: 100 }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'organizationName',
        {
          packageReporting: ['packageReportingStartDate', 'packageReportingEndDate']
        }
      )
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        organizationName: undefined,
        wipEntityName: undefined,
        lotNumber: undefined,
        packageReporting: undefined,
        packageReportingStartDate: undefined,
        packageReportingEndDate: undefined
      }
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
